import { cn } from 'lib/helpers/utility';

const Body = ({ body, childrenClassName }) => {
  if (!body) return null;

  return (
    <div className={cn('border-0 border-b border-solid border-neutral-200 p-5', childrenClassName)}>
      {body}
    </div>
  );
};

export default Body;
